import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Echo ripple effect
document.addEventListener('click', (e) => {
  const button = e.target.closest('button');
  if (!button) return;
  const ripple = document.createElement('span');
  ripple.className = 'echo-ripple';
  const rect = button.getBoundingClientRect();
  ripple.style.left = `${e.clientX - rect.left}px`;
  ripple.style.top  = `${e.clientY - rect.top}px`;
  button.appendChild(ripple);
  ripple.addEventListener('animationend', () => ripple.remove());
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);